<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div class="card-head box-shadow bg-white d-md-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" >
        <form class="search-box position-relative" @submit.prevent="rechercher">
          <!--<input
            type="text"
            v-model="searchTerm"
            @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0"
            placeholder="Rechercher une vente"
          />
          <button
            type="submit"
            class="bg-transparent text-primary transition p-0 border-0"
          >
            <i class="flaticon-search-interface-symbol"></i>
          </button>-->
        </form>
        <div class="d-sm-flex align-items-center">

          <router-link to="/Ajout-Vente" class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none">
            <i class="flaticon-plus position-relative ms-5 fs-12"></i>
            <span class="title">Nouvelle vente</span>
          </router-link>
          
          <button
            class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mt-10 mt-md-0"
            type="button"
          >
            Export
            <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
          </button>
        </div>

      </div>

      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="col-md-12">
        <div class="row">
          <!-- <form class="row" @submit.prevent="rechercher"> -->
            
            <div class="col">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                 Mot clé
                </label>
                <Field 
                  style="max-height: 42px;"
                  v-model="searchTerm"
                  @keyup="rechercher" 
                  name="mot" 
                  type="text" 
                  aria-disabled="true"
                  class="form-control shadow-none fs-md-15 text-black" 
                  placeholder="Recherche par mot clé"/>
              </div>
            </div>
  
            <div class="col">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Date Debut
                </label>
                <Field name="dateDebut" type="date" v-model="_dateDebut"  :value="getCurrentDate()"
                class="form-control shadow-none fs-md-15 text-black"/>
                <ErrorMessage name="dateDebut" class="text-danger"/>
              </div>
            </div>
  
            <div class="col">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Date Fin 
                </label>
                <Field name="dateFin" type="date"  v-model="_dateFin"  :value="getCurrentDate()"
                class="form-control shadow-none fs-md-15 text-black"/>
                <ErrorMessage name="dateFin" class="text-danger"/>
              </div>
            </div>

            <div class="col">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Client 
                </label>
                <Field v-model="_client" name="client" v-slot="{ field }">
                  <Multiselect
                    :options="
                    async (query) => {
                      const results = await searchClient(query);
                      if (results && results.length > 0) {
                        return results;
                      } else if (query.length >= 3) {
                        return [
                          { value: '', label: 'Aucun enregistrement trouvé' },
                        ];
                      } else {
                        return [];
                      }
                    }"
                    noOptionsText="Tapez au moins deux caractères"
                    :filter-results="false" 
                    :min-chars="3" 
                    :delay="0"
                    :searchable="true"
                    v-model="field.value"
                    v-bind="field"
                    placeholder="Sélectionner un client"
                  />
                </Field>
                <ErrorMessage name="client" class="text-danger"/>
              </div>
            </div>
            
  
          <!-- </form> -->
        </div>
        </div>
        <hr>

        <div class="table-responsive">
          <table class="table text-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                >
                  #
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  date
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                >
                  client
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  montant
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  montant sans epargne
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(vente, index) in elements" :key="index">
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ vente.id }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{  formatDate(vente.dateVente) }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ '[ '+vente.client.code+' ] '+vente.client.prenoms+ ' ' + vente.client.nom }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ vente.montant }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ (vente.montant)? vente.montantSansEpargne : '-' }}
                </td>
                <td
                class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0"
                >
                  <div class="dropdown">
                      <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                          Actions
                          <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                      </span>
                      <ul class="dropdown-menu">
                        <li>
                          <a
                            class="dropdown-item d-flex align-items-center"
                            href="javascript:void(0);"
                            data-bs-toggle="modal"
                            data-bs-target="#MyModal"
                            @click="detail(vente.id)"
                          >
                            <i
                              class="flaticon-delete lh-1 me-8 position-relative top-1" 
                            ></i>
                            Détail
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item d-flex align-items-center"
                            href="javascript:void(0);" @click="fetchPdfUrl(vente)"
                          >
                            <i
                              class="flaticon-delete lh-1 me-8 position-relative top-1" 
                            ></i>
                            Voir la fiche
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item d-flex align-items-center"
                            href="javascript:void(0);" @click="regenererLettreDengagement(vente.id)"
                          >
                            <i
                              class="flaticon-delete lh-1 me-8 position-relative top-1" 
                            ></i>
                            Regenérer la lettre d'engagement
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item d-flex align-items-center"
                            href="javascript:void(0);" 
                            data-bs-toggle="modal"
                            data-bs-target="#MyModalReglement"
                            @click="detailReglement(vente.id)"
                          >
                            <i
                              class="flaticon-delete lh-1 me-8 position-relative top-1" 
                            ></i>
                            Voir les règlements
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item d-flex align-items-center"
                            href="javascript:void(0);" @click="regulariserReglement(vente.id)"
                          >
                            <i
                              class="flaticon-delete lh-1 me-8 position-relative top-1" 
                            ></i>
                            Régulariser le règlement
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item d-flex align-items-center"
                            href="javascript:void(0);" @click="genererFacture(vente.id)"
                          >
                            <i
                              class="flaticon-delete lh-1 me-8 position-relative top-1" 
                            ></i>
                            Generer la facture
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item d-flex align-items-center"
                            href="javascript:void(0);" @click="suppression(vente.id,elements,'vente','cette vente ?')"
                          >
                            <i
                              class="flaticon-delete lh-1 me-8 position-relative top-1" 
                            ></i>
                            Annuler cette vente
                          </a>
                        </li>
                      </ul>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="3" class="text-end"> Total : </td>
                <td> <h6> <b> {{ formatMontant(total) }}</b></h6>  </td>
                <td> <h6> <b> {{ formatMontant(totalSansEpargne) }}</b></h6>  </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
          <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
        </div>
      </div>
    </div>

    <!-- MODAL DETAIL VENTE-->
    <div class="modal fade createNewModal" id="MyModal" tabindex="-1"  aria-hidden="true" >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content p-15 p-md-40">
          <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
            <h5 class="modal-title fw-bold text-black">Détails</h5>
          </div>
          <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25">
            <div class="table-responsive">
            
              <table class="table text-nowrap align-middle mb-0">
                <tbody v-if="element">
                  <tr>
                    <th> DATE </th>
                    <td> {{  (element.dateVente) ? formatDate(element.dateVente) : "" }} </td>
                    <th> MONTANT </th>
                    <td> {{ (element.montant) ? formatMontant(element.montant) : "" }} </td>
                  </tr>
                </tbody>
              </table>

              <div v-if="element">
                <table class="table text-nowrap align-middle mb-0" style="width: 100%">
                  <tbody>
                    <tr>
                      <th> # </th>
                      <th> PRODUIT </th>
                      <th> PRIX </th>
                      <th> QTE </th>
                      <th> MONTANT </th>
                    </tr>
                    <tr v-for="(prod, indexx) in element.prodCondVentes" :key="indexx">
                      <td> {{ prod.id }} </td>
                      <td> {{ prod.nomComplet }} </td>
                      <td> {{ prod.prix }} </td>
                      <td> {{ prod.qteVendu }} </td>
                      <td> {{ (prod.qteVendu * prod.prix) }} </td>
                    </tr>
                  </tbody>
                </table>
              </div>
                  
            </div>
          </div>

          <button
            type="button"
            class="btn-close shadow-none"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>

        </div>
      </div>
    </div>

    <!-- MODAL DETAIL REGLEMENTS-->
    <div class="modal fade createNewModal" id="MyModalReglement" tabindex="-1"  aria-hidden="true" >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content p-15 p-md-40">
          <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
            <h5 class="modal-title fw-bold text-black">Détails Reglement</h5>
          </div>
          <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25">
            <div class="table-responsive">
            
              <table class="table text-nowrap bg-default align-middle mb-0">
                <tbody v-if="elementReglement">
                  <tr>
                    <th> CLIENT </th>
                    <td> {{ elementReglement[0]?.vente?.client?.nom +' '+elementReglement[0]?.vente?.client?.prenoms }} </td>
                    <th> VENTE </th>
                    <td> {{ '#'+elementReglement[0]?.vente?.id }} </td>
                    <th> TOTAL REGLER </th>
                    <td> {{ formatMontant(totalReglement) }} </td>
                  </tr>
                </tbody>
              </table>

              <div v-if="elementReglement">
                <table class="table text-nowrap align-middle mb-0" style="width: 100%">
                  <tbody>
                    <tr>
                      <th> # </th>
                      <th> DATE </th>
                      <th> MONTANT </th>
                      <th> MONTANT RESTANT </th>
                    </tr>
                    <tr v-for="(reg, inde) in elementReglement" :key="inde">
                      <td> {{ reg.id }} </td>
                      <td> {{ formatDate(reg.dateReglement) }} </td>
                      <td> {{ formatMontant(reg.montant) }} </td>
                      <td> {{ formatMontant(reg.restAPayer) }} </td>
                    </tr>
                  </tbody>
                </table>
              </div>
                  
            </div>
          </div>

          <button
            type="button"
            class="btn-close shadow-none"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>

        </div>
      </div>
    </div>

  </template>
  
<script lang="ts">
import { defineComponent, ref, onMounted, watch } from 'vue';
import { paginationFields } from '../Utilities/paginationFields';
import { Form, Field, ErrorMessage } from 'vee-validate';
import Multiselect from '@vueform/multiselect';
import { error, suppression, format_date, getCurrentDate, openNewWindow, success } from '../../utils/utils';
import ApiService from "../../services/ApiService";
import  { Vente }  from '../../models/Vente';
import { Reglement } from '../../models/Reglement';
import PaginationComponent from '@/components/Utilities/Pagination.vue';

  export default defineComponent({
    name: "ListeVente",
    components: {
      PaginationComponent,
      Field,
      Multiselect,

    },
    setup: () => {

      const elements = ref<Array<Vente>>([])
      const selectedItem = ref(0);
      const element = ref<Vente>();
      const elementReglement = ref<Array<Reglement>>([]);
      const totalReglement = ref(0);
      const _client = ref('');
      const _dateDebut = ref('');
      const _dateFin = ref('');
      const clientOptions = ref([]);
      const total = ref(0);
      const totalSansEpargne = ref(0);

      // BEGIN PAGINATE
      const searchTerm = ref('');
      const page = ref(1);
      const totalPages = ref(0);
      const limit = ref(10);
      const totalElements = ref(0);

      const handlePaginate = ({ page_, limit_ }) => {
        try {
          page.value = page_;
          getAll(page_, limit_, searchTerm.value, _dateDebut.value ?? undefined, _dateFin.value ?? undefined, _client.value ?? undefined);
        } catch (error) {
          console.log("erroe,", error);
        }
      };

      watch([_dateDebut, _dateFin, _client, searchTerm], () => {
        rechercher();
      });

      function rechercher(){
        getAll(page.value, limit.value, searchTerm.value, _dateDebut.value ?? undefined, _dateFin.value ?? undefined, _client.value ?? undefined);
      }
      // END PAGINATE
    

      const recharger = () => {
        getAll();
      };

      onMounted(() => {
        getAll();
      })

      function fetchPdfUrl(data: any, dossier = "Engagement") {
        openNewWindow('Engagement_' + data.id, dossier);
      }

      const searchClient = async (key) => {
        try {
          const  data  = await ApiService.get("/clients/recherche/" + key);
          clientOptions.value = data.data.data.map((p) => ({
            value: p.id,
            label: "[ " + p.code + " ] " + p.nom + " " + p.prenoms,
          }));
          console.log("clients", clientOptions.value);
          return clientOptions.value;
        } catch (error) {
          // produitsError.value = true;
          return [];
        }
      };

      function regenererLettreDengagement(id) {
        return ApiService.get(`ventes/regenerer/lettre/${id}`)
        .then(({ data }) => {
          console.log('pdf url', data);
          success(data.message);
          // openNewWindow('Lettre_Engagement_' + id, 'Engagement');
        })
        .catch(({ response }) => {
          error(response.data)
          console.log("error", response);
        });
      }

      function regulariserReglement(id) {
        return ApiService.get(`reglements/regulariser/vente/${id}`)
        .then(({ data }) => {
          console.log('pdf url', data);
          success(data.message);
        })
        .catch(({ response }) => {
          error(response.data)
          console.log("error", response);
        });
      }


      function genererFacture(id) {
        return ApiService.get(`factures/generer/${id}`)
        .then(({ data }) => {
          console.log('pdf url', data);
          success(data.message);
          // openNewWindow('Facture_' + id, 'Facture');
        })
        .catch(({ response }) => {
          error(response.data)
          console.log("error", response);
        });
      }

      function getAll(page = 1, limi = 10, searchTerm = '', _dateDebut = '' , _dateFin = '', _client = '') {
        return ApiService.get(`ventes?page=${page}&limit=${limi}&mot=${searchTerm}&dateDebut=${_dateDebut}&dateFin=${_dateFin}&client=${_client}&`)
        .then(({ data }) => {
          elements.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          total.value = data.data.totalVente.total;
          totalSansEpargne.value = data.data.totalVenteSansEpargne.totalSansEpargne;
          console.log("yes",data.data);
        })
        .catch(({ response }) => {
          error(response.data)
          console.log("error", response);
        });
      } 

      function detail(id) {
        return ApiService.get(`vente/${id}`)
        .then(({ data }) => {
          console.log('vente', data.data);
          element.value = data.data;
        })
        .catch(({ response }) => {
          error(response.data)
        });
      }

      function detailReglement(id) {
        console.log("id", id);
        return ApiService.get(`reglements/vente/${id}`)
        .then(({ data }) => {
          console.log('reglements', data.data);
          elementReglement.value = data.data;
          totalReglement.value = data.data.reduce((acc, item) => acc + item.montant, 0);
        })
        .catch(({ response }) => {
          console.log("error", response.data);
          error(response.data);
        });
      }

      function formatDate(dateString) {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      }

      function formatMontant(montant) {
        montant = parseFloat(montant);
        return montant.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      }

      return { 
        getAll,
        detailReglement,
        suppression,
        elements,
        recharger,
        selectedItem,
        format_date,
        fetchPdfUrl,
        element,
        detail,
        formatMontant,
        formatDate,
        _client,
        _dateDebut,
        _dateFin,
        searchClient,
        getCurrentDate,
        total,
        totalSansEpargne,
        elementReglement,
        totalReglement,

        page,
        totalPages,
        totalElements,
        limit,
        searchTerm,
        handlePaginate,
        rechercher,
        regenererLettreDengagement,
        regulariserReglement,
        genererFacture
      };
    }

  });
  
</script>